import {
  Box,
  FormControlLabel,
  IconButton,
  Radio,
  Skeleton,
  useTheme,
} from 'hephaestus/web';
import { ExpandLess, ExpandMore } from 'hephaestus/webIcons';
import { useLocalization } from '../../../hooks/useLocalization';
import type { OrganizationTreeNode } from './organizationSwitcherModal.query';

export type OrganizationTreeBranchProp = {
  branch: OrganizationTreeNode;
  root?: boolean;
  onSelect: (id: string) => void;
  onOpen: (id: string) => void;
  onClose: (id: string) => void;
};

export const OrganizationTreeBranch = ({
  branch,
  root = true,
  onSelect,
  onOpen,
  onClose,
}: OrganizationTreeBranchProp) => {
  const { translateBackendString } = useLocalization();
  const theme = useTheme();

  return (
    <Box
      sx={{
        pl: root ? 0 : 2,
      }}
    >
      {branch.translatedName ? (
        <Box
          id={branch.id}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 2,
            pl: 1,

            '&:hover': {
              background: theme.color.surfaceContainerVariant,
            },

            borderRadius: theme.borderRadius.md,
          }}
        >
          <FormControlLabel
            value={branch.id}
            control={<Radio />}
            label={translateBackendString(branch.translatedName)}
          />

          {branch.children && branch.children.length > 0 && (
            <IconButton
              aria-label='collapse'
              sx={{ color: theme.color.onSurface }}
              size='small'
              onClick={() => {
                if (branch.open) {
                  onClose(branch.id);
                  return;
                }
                void onOpen(branch.id);
              }}
            >
              {branch.open ? (
                <ExpandLess fontSize='inherit' />
              ) : (
                <ExpandMore fontSize='inherit' />
              )}
            </IconButton>
          )}
        </Box>
      ) : (
        <Box
          sx={{
            pt: 1,
            pr: 3,
            pl: 2,
          }}
        >
          <Skeleton
            width='100%'
            height='34px'
            variant='rectangular'
            sx={{ borderRadius: theme.borderRadius.md }}
          />
        </Box>
      )}
      {branch.open &&
        branch.children?.map((child) => (
          <OrganizationTreeBranch
            key={child.id}
            branch={child}
            root={false}
            onSelect={onSelect}
            onOpen={onOpen}
            onClose={onClose}
          />
        ))}
    </Box>
  );
};
